/**
 * Adapter de notificaciones para Web
 *
 * Implementa NotificationPort usando el sistema de toasts existente.
 */

import type { NotificationPort, NotificationOptions } from '@pepi/core'
import { useToast } from '@/composables/useToast'

/**
 * Implementación de NotificationPort para Web usando useToast
 */
export class WebNotificationAdapter implements NotificationPort {
  private toast: ReturnType<typeof useToast>

  constructor() {
    this.toast = useToast()
  }

  show(options: NotificationOptions): void {
    switch (options.type) {
      case 'success':
        this.toast.success(options.message)
        break
      case 'error':
        this.toast.error(options.message)
        break
      case 'warning':
        this.toast.warning(options.message)
        break
      case 'info':
      default:
        this.toast.info(options.message)
        break
    }
  }

  success(message: string, _title?: string): void {
    this.toast.success(message)
  }

  error(message: string, _title?: string): void {
    this.toast.error(message)
  }

  warning(message: string, _title?: string): void {
    this.toast.warning(message)
  }

  info(message: string, _title?: string): void {
    this.toast.info(message)
  }

  dismissAll(): void {
    // El sistema de toasts actual no soporta dismissAll
    // Se puede implementar si se necesita
    console.warn('dismissAll not implemented in current toast system')
  }
}

/**
 * Crea una instancia del adapter de notificaciones para web
 */
export function createWebNotificationAdapter(): NotificationPort {
  return new WebNotificationAdapter()
}
